<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'产品管理'},{title:'期望交货日期审批'}]" />
        <div class="h-content">
            <el-form
                :model="zy"
                label-position="right"
                ref="zy"
                :rules="rules"
                :inline="true"
                class="demo-ruleForm h-formbLine h-formbLine1">
                <div class="h-row h-mrt1">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                    <div class="h-rowCon">
                        <div class="h-pieceIn2 mylyx">
                        <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->

                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                            <h1>采购订单信息</h1>
                        </div>
                        <el-table :data="list">
                            <!-- <el-table-column type="selection" width="45" :label="all"></el-table-column> -->
                            <el-table-column fixed type="index" label="#" width="40"></el-table-column>
                            <el-table-column
                            prop="productCode"
                            label="产品编号"
                            width="230"
                            :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                            prop="productModel"
                            label="产品型号"
                            min-width="130"
                            :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                            prop="levelCodeName"
                            label="产品大类"
                            width="230"
                            :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                            prop="status"
                            label="商品状态"
                            width="150"
                            :show-overflow-tooltip="true"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.status==1">有效</span>
                                <span v-if="scope.row.status==0">无效</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="deliveryDay"
                            label="有效天数"
                            width="110"
                            :show-overflow-tooltip="true"
                            ></el-table-column>

                            <el-table-column
                            prop="expriationDate"
                            label="失效日期"
                            width="140"
                            :show-overflow-tooltip="true"
                            ></el-table-column>
                        </el-table>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div class="h-row h-mrt1">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                    <div class="h-rowCon">
                        <div class="h-pieceIn2 mylyx">
                        <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                        <div class="h-pieceTitle2" style="margin: 0 0 0.3rem 0;">
                            <h1>审核信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                            <div class="h-formLine dingdan3" style="position: relative;">
                            <el-form-item
                                label="审批意见"
                                class="h-elformWrap-2 newBox"
                                :required="true"
                                style="width: 100%!important;"
                            >
                                <el-input v-model="zy.remarks" placeholder="请输入"></el-input>
                            </el-form-item>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </el-form>
        <div class="apprButton">
            <el-button  class="h-btn h-bBtn h-bgred" @click="refuse">驳回</el-button>
            <el-button  class="h-btn h-bBtn h-bggreen" @click="pass">通过</el-button>
            <!-- <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button> -->
        </div>

        <!--地址信息-->
        <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
    </div>
</template>

<script>
import ss from "../../api/SystemService";
import util from "../../utils/util";
import big from "big.js";

export default {
    data() {
        return {
        feilList: [
            { value: 0, label: "0%" },
            { value: 3, label: "3%" },
            { value: 6, label: "6%" },
            { value: 9, label: "9%" },
            { value: 13, label: "13%" }
        ],
        beihuoflag: false,
        beihuolist: [],
        showdizhiflag: false,
        //带线表单
        value: false,
        showhistory: false,
        orderId: this.$route.query.ywid,
        instid: this.$route.query.instid,
        taskId: this.$route.query.taskid,
        link: this.$route.query.link || "",
        options1: [],
        options2: [],
        list: [],
        zy: {
            caigouquyu: "1",
            numlist: null,
            suserCode: "",
            productCate: "",
            type: "",
            typeName: "",
            productNo: "",
            waybillType: "",
            unitPrice: "",
            count: "",
            totalPrice: "",
            detailAddress: "",
            expectDate: "",
            productCateName: "",
            productDes: "",
            suserName: "",
            status: 0,
            proId: "",
            cgGroupCode: "",
            province: "",
            city: "",
            country: "",
            purchaseOrgCode: "",
            ycId: "",
            remarks:''
        },
        vs: {
            productId: ""
        },
        rules: {
            suserCode: [
            { required: true, message: "请选择供应商名称", trigger: "blur" }
            ],
            expectDate: [
            { required: true, message: "请选择期货时间", trigger: "change" }
            ],
            waybillType: [
            { required: true, message: "请选择物流类型", trigger: "change" }
            ],
            cgGroupCode: [
            { required: true, message: "请选择采购组", trigger: "change" }
            ],
            remarks:[{ required: true, message: "审批意见不能为空", trigger: "blur" }]
        },
        taskstatus: this.$route.query.taskstatus
        };
    },
    methods: {
        refuse() {
            this.list[0].remarks = this.zy.remarks
            this.list[0].taskid = this.taskId
            if(this.zy.remarks == '' || this.zy.remarks == undefined){
                this.$message.error("请先填写审批意见！");
            }else{
                var submitobj =this.list
                console.log(submitobj)
                ss.chanpin.checkRejectPM(submitobj).then(res => {
                    if(res.f == true){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.$router.push({path:"/personal/dealCenter"})
                    }else{
                        this.$message.error(res.msg);
                        tthis.$router.push({path:"/personal/dealCenter"})
                    }
                })

            }

            // this.zy.orderCgList.forEach((item, index) => {
            //     this.zy.orderCgList[index].expectDate = util.riQi6(
            //     this.zy.orderCgList[index].expectDate
            //     );
            // });
            // if (this.zy.expectDate) {
            //     this.zy.expectDate = util.riQi6(this.zy.expectDate);
            // }
            // ss.orderCgService.approveFail(this.zy).then(rd => {
            //     if (rd.f) {
            //     this.$msg.msgs(rd.msg);
            //     this.$store.dispatch("searchTasktotal");
            //     this.$router.push("purchaselist");
            //     } else {
            //     this.$msg.msgs("审批失败！" + rd.msg);
            //     }
            // });
        },
        pass() {
            console.log(this.zy.remarks)
            this.list[0].remarks = this.zy.remarks
            this.list[0].taskid = this.taskId
            // var msg = [];
            // this.zy.orderCgList.forEach((item, index) => {
            //     if (item.suserCode == null || item.suserCode == "") msg.push("供应商");
            //     if (item.expectDate == null || item.expectDate == "")
            //     msg.push("期望到货时间");
            //     if (item.waybillType == null || item.waybillType == "")
            //     msg.push("物流类型");
            //     if (item.cgGroupCode == null || item.cgGroupCode == "")
            //     msg.push("采购组");
            //     if (item.purchaseOrgCode == null || item.purchaseOrgCode == "")
            //     msg.push("采购组织");
            //     if (item.expectDate != null && item.expectDate != "") {
            //     item.expectDate = util.riQi6(item.expectDate);
            //     }

            //     item.detailAddress = this.zy.detailAddress;
            //     item.detailAddress = this.zy.detailAddress;
            //     item.province = this.zy.province;
            //     item.city = this.zy.city;
            //     item.country = this.zy.country;
            //     item.receiver = this.zy.receiver;
            //     item.receverPhone = this.zy.receverPhone;
            //     item.receiveUnit = this.zy.receiveUnit;
            // });
            // if (msg.length > 0) {
            //     msg = _.uniq(msg);
            //     this.$msg.msge("请选择" + msg.join("、") + "。");
            //     return;
            // }
            //var submitobj = this.list
            var submitobj = this.list
            console.log(submitobj)
            ss.chanpin.checkPassPM(submitobj).then(res => {
                if(res.f == true){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.$router.push({path:"/personal/dealCenter"})
                    //  /personal/dealCenter
                }else{
                    this.$message.error(res.msg);
                    this.$router.push({path:"/personal/dealCenter"})
                }
                // if (res.f) {
                //     console.log(res)
                //     // this.$msg.msgs(rd.msg);
                //     // this.$store.dispatch("searchTasktotal");
                //     // if (this.link == 0) {
                //     //     this.$router.push("/personal/dealCenter");
                //     // } else if (this.link == 1) {
                //     //     this.$router.push("/dingd/purchaselistNx");
                //     // } else if (this.link == 2) {
                //     //     this.$router.push("/dingd/purchaselistWx");
                //     // } else if (this.link == 3) {
                //     //     this.$router.push("/dingd/purchaselist");
                //     // } else {
                //     //     this.$router.push("/personal/dealCenter");
                //     // }
                // } else {
                //     this.$msg.msgs("审批失败！" + res.msg);
                // }
            });
        }
    },
    mounted() {
        if (this.instid != null) {
        //查看订单详情
        var instid = this.instid;
        ss.chanpin.selectByInstid(instid).then(rd => {
            //初始化默认数据
            this.zy = rd.obj;
            console.log(this.zy);
            this.list = rd.obj;
            console.log(this.list);
            // //this.zy.typeName=this.$getDictName("cg_type",this.zy.type);
            // if (this.zy) {
            // for (var i = 0; i < this.zy.length; ) {
            //     var item = this.zy[i];
            //     //获取供应商列表
            //     if (item.productNo) {
            //     ((i, matecode) => {
            //         ss.ProService.supplierByProductId({ productId: matecode }).then(
            //         rd => {
            //             if (rd && rd.length > 0) {
            //             this.options2[i] = rd;
            //             this.$set(this.options2, i, rd);
            //             }
            //         }
            //         );
            //         //加载该产品做过的采购单
            //         ss.orderCgService
            //         .getBeihuoList({ matecode: item.productNo })
            //         .then(rd => {
            //             this.beihuolist[i] = rd;
            //             this.$set(this.beihuolist, i, rd);
            //         });
            //     })(i, item.productNo);
            //     }
            //     this.options1[i] = this.$store.getters.dicts["waybill_type"];

            //     i++;
            // }

            // if (this.zy.des) {
            //     this.zy.des = "";
            // }
            // if (typeof this.zy.des != "undefined" && "" != this.zy.des) {
            //     this.$set(this.zy.des, "");
            // }
            // this.zy.taskId = this.taskId;
            // }
        });
        }
    },
    created() {
        // this.options1 = this.$store.getters.dicts["waybill_type"];
    }
};
</script>

<style scoped>
    .canClickCls {
    color: blue;
    }
    .passfollow {
    position: absolute;
    right: 0;
    bottom: 0.4rem;
    background-color: #2785e7;
    color: white;
    }
    .h1 {
    margin: 20px 0 0 31px;
    }
    .bbbb {
    background-color: white;
    padding-bottom: 30px;
    }
    .apprButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0.3rem 0;
    }

    .cancel {
    width: 18%;
    }

    .pass {
    background-color: #006aca;
    color: white;
    width: 18%;
    }

    .refuse {
    background-color: #24b5b8;
    color: white;
    width: 18%;
    }
</style>
<style>
    .mylyx .h-tableInput .el-input__inner {
    padding: 0.05rem 0.1rem;
    }
    .mylyx .el-input__suffix .el-input__icon {
    line-height: 0.2rem;
    }
    .mylyx .el-input__prefix .el-input__icon {
    line-height: 0.2rem;
    }
    .dingdan3.h-formLine .el-form-item__label {
    width: 31%;
    text-align: right;
    }
    .dingdan3.h-formLine .newBox .el-form-item__label {
    width: 9.7%;
    text-align: right;
    }

    .dingdan3.h-formLine .el-form-item__content {
    width: 69%;
    }
    .dingdan3.h-formLine .newBox .el-form-item__content {
    width: 90.3%;
    }
    .dingdan3.h-formLine .h-elformWrap-2 {
    width: 33.333%;
    padding-right: 0.5rem;
    }
</style>
